import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import Alert from '@material-ui/lab/Alert'
import DynamicFormattedMessage from '@voicekey/components-base/dynamicFormattedMessage/DynamicFormattedMessage'
import PropTypes from 'prop-types'
import { SEVERITIES } from './Message.const'
import { FormattedMessage, useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import { useToggle } from '@voicekey/libraries/useToggle/useToggle'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'
import styles from './Message.styles'
import Tooltip from '@material-ui/core/Tooltip'

const useStyles = makeStyles(styles, { name: 'Message' })

function Message ({ onClose, message, moreReference, alertProps, ...props }) {
  const intl = useIntl()
  const classes = useStyles()

  const getFormattedMessage = notFormattedMessage => {
    return intl.messages[notFormattedMessage.id] ? notFormattedMessage : (
      message.severity === SEVERITIES.ERROR ? ({
        id: 'UNDEFINED_ERROR',
        defaultMessage: 'Undefined error'
      }) : ({
        id: 'undefined_message',
        defaultMessage: 'Undefined message'
      })
    )
  }

  const [isTooltipOpen, toggleIsTooltipOpen] = useToggle()

  const getMessage = notFormattedMessage => {
    return notFormattedMessage.translated ? notFormattedMessage.id : (
      <DynamicFormattedMessage {...getFormattedMessage(notFormattedMessage)} />
    )
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open
      autoHideDuration={6000}
      onClose={onClose}
      {...props}
    >
      <Alert
        onClose={onClose}
        severity={message.severity}
        closeText={intl.formatMessage({ id: 'close', defaultMessage: 'Close' })}
        className={classes.alert}
        {...alertProps}
      >
        {getMessage(message.mainMessage)}
        {message.info && (
          <>. {getMessage(message.info)}</>
        )}
        {moreReference && (
          <>
            <span>. </span>
            <Link to={moreReference}>
              <FormattedMessage id='more' defaultMessage='Details' />...
            </Link>
          </>
        )}
        {message.tooltip && (
          <>
            <Tooltip title={
              isTooltipOpen
                ? <FormattedMessage id='collapse' defaultMessage='Collapse' />
                : <FormattedMessage id='expand' defaultMessage='Expand' />
            }
            >
              <IconButton
                onClick={toggleIsTooltipOpen}
                className={classes.moreIconButton}
              >
                {isTooltipOpen ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Tooltip>
            {isTooltipOpen && (
              <Collapse in className={classes.tooltip}>
                {message.tooltip}
              </Collapse>
            )}
          </>
        )}
      </Alert>
    </Snackbar>
  )
}

Message.propTypes = {
  onClose: PropTypes.func.isRequired,
  message: PropTypes.shape({
    severity: PropTypes.oneOf(Object.values(SEVERITIES)).isRequired,
    mainMessage: PropTypes.shape({
      id: PropTypes.string.isRequired,
      defaultMessage: PropTypes.string,
      values: PropTypes.object
    }).isRequired,
    info: PropTypes.shape({
      id: PropTypes.string.isRequired,
      defaultMessage: PropTypes.string,
      values: PropTypes.object
    }),
    tooltip: PropTypes.string
  }).isRequired,
  moreReference: PropTypes.string,
  alertProps: PropTypes.object
}

export default Message
